import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningAmberIcon from "@mui/icons-material/WarningAmber"; 

export const CustomToast = ({ message, type }) => {
  let icon, borderColor;

  switch (type) {
    case "success":
      icon = <CheckCircleIcon sx={{ color: "#17AE7D" }} />;
      borderColor = "#17AE7D";
      break;
    case "error":
      icon = <ErrorIcon sx={{ color: "#E53935" }} />;
      borderColor = "#E53935";
      break;
    case "info":
       case "warning": // ✅ new case
      icon = <WarningAmberIcon sx={{ color: "#FFA000" }} />; // Material amber
      borderColor = "#FFA000";
      break;
    default:
      icon = <InfoIcon sx={{ color: "#3F6CFF" }} />;
      borderColor = "#3F6CFF";
      break;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: 2,
        minWidth: 320,
        bgcolor: "#fff",
        borderRadius: 2,
        boxShadow: 3,
        borderLeft: `4px solid ${borderColor}`,
      }}
    >
      {icon}
      <Typography variant="body2" color="text.primary" fontWeight={500}>
        {message}
      </Typography>
    </Box>
  );
};
